import React, { useEffect, useState } from "react";
import { useHistory } from "react-router";
import classNames from "classnames";
import PropTypes from "prop-types";

// @material-ui/core components
import ClickAwayListener from "@material-ui/core/ClickAwayListener";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { makeStyles } from "@material-ui/core/styles";
import Typography from "@material-ui/core/Typography";
import MenuList from "@material-ui/core/MenuList";
import MenuItem from "@material-ui/core/MenuItem";
import Divider from "@material-ui/core/Divider";
import Tooltip from "@material-ui/core/Tooltip";
import Person from "@material-ui/icons/Person";
import Switch from "@material-ui/core/Switch";
import Popper from "@material-ui/core/Popper";
import Paper from "@material-ui/core/Paper";
import Grow from "@material-ui/core/Grow";
import Box from "@material-ui/core/Box";

import { isFdaViewEnabled, roleMapping, setFdaView } from "common/helpers.js";
import styles from "assets/jss/material-dashboard-pro-react/components/adminNavbarLinksStyle.js";
import ThemeToggle from "components/ThemeToggle/ThemeToggle.js";
import { clearApiCache } from "common/idbCache";
import pjson from "../../../package.json";

const useStyles = makeStyles(styles);
export default function HeaderLinks(props) {
  const history = useHistory();

  const [fdaView, setFdaViewState] = useState(isFdaViewEnabled());
  const [userFacility, setUserFacility] = useState("");
  const [userCompany, setUserCompany] = useState("");
  const [userName, setUserName] = useState("");
  const [userRole, setUserRole] = useState("");

  const handleFdaViewToggle = (event) => {
    const enabled = event.target.checked;
    setFdaViewState(enabled);
    setFdaView(enabled);
    // Reload so route visibility (FDA_HIDDEN_ROUTES) re-applies across the app
    window.location.reload();
  };

  useEffect(() => {
    const userDetails = JSON.parse(localStorage.getItem("user-details") ?? "{}") || {};
    let role = userDetails?.roles?.[0]?.role || "Resident";
    role = roleMapping(role);
    if(["Company Admin", "Company User", "Facility Admin", "Facility User", "Care Team"].includes(role)) {
      setUserCompany(userDetails?.roles?.[0]?.supplier?.name);
      setUserFacility(userDetails?.roles?.[0]?.practice?.name);
    }
    setUserName(userDetails?.fullName);
    setUserRole(role);
  }, []);

  const [openProfile, setOpenProfile] = React.useState(null);
  const handleClickProfile = (event) => {
    if (openProfile && openProfile.contains(event.target)) {
      setOpenProfile(null);
    } else {
      setOpenProfile(event.currentTarget);
    }
  };
  const handleCloseProfile = () => {
    setOpenProfile(null);
  };
  const classes = useStyles();
  const { rtlActive } = props;
  const dropdownItem = classNames(classes.dropdownItem, classes.primaryHover, {
    [classes.dropdownItemRTL]: rtlActive,
  });
  const wrapper = classNames({
    [classes.wrapperRTL]: rtlActive,
  });
  const managerClasses = classNames({
    [classes.managerClasses]: true,
  });
  const companyLabel =
    isFdaViewEnabled() && userCompany?.toLocaleLowerCase() === "general wellness"
      ? "ATS2410-ME"
      : userCompany;

  return (
    <Box className={classes.navContainer}>
      {userCompany && (
        <>
          <Tooltip title={userFacility ? `${companyLabel} - ${userFacility}` : companyLabel}>
            <span className={classes.orgChip}>
              {companyLabel}
              {userFacility && ` - ${userFacility}`}
            </span>
          </Tooltip>
          <span className={classes.verticalDivider} />
        </>
      )}

      <Tooltip title="Application version">
        <span className={classes.versionBadge}>v{pjson.version}</span>
      </Tooltip>

      <span className={classes.verticalDivider} />

      <ThemeToggle />

      <span className={classes.verticalDivider} />

      <FormControlLabel
        className={classes.viewToggleWrap}
        control={
          <Switch
            checked={fdaView}
            onChange={handleFdaViewToggle}
            color="primary"
            size="small"
          />
        }
        label={
          <Typography className={classes.viewToggleLabel}>
            {fdaView ? "H-R View" : "Default View"}
          </Typography>
        }
      />

      <span className={classes.verticalDivider} />

      {userName && (
        <div className={managerClasses}>
          <div className={classes.userBlock}>
            <p className={classes.userNameText}>{userName}</p>
            {userRole && <p className={classes.userRoleText}>{userRole}</p>}
          </div>
        </div>
      )}

      <div className={wrapper}>
        <div className={managerClasses}>
          <button
            type="button"
            aria-label="Profile menu"
            aria-owns={openProfile ? "profile-menu-list" : null}
            aria-haspopup="true"
            onClick={handleClickProfile}
            className={classes.avatarButton}
          >
            <Person className={classes.avatarIcon} />
          </button>
          <Popper
            open={Boolean(openProfile)}
            anchorEl={openProfile}
            transition
            disablePortal
            placement="bottom"
            className={classNames({
              [classes.popperClose]: !openProfile,
              [classes.popperResponsive]: true,
              [classes.popperNav]: true,
            })}
          >
            {({ TransitionProps }) => (
              <Grow
                {...TransitionProps}
                id="profile-menu-list"
                style={{ transformOrigin: "0 0 0" }}
              >
                <Paper className={classes.dropdown}>
                  <ClickAwayListener onClickAway={handleCloseProfile}>
                    <MenuList role="menu">
                      <MenuItem
                        onClick={() => {
                          const data = JSON.parse(
                            localStorage.getItem("user-details")
                          );
                          const loggedUserRole = data !== null ? data.roles[0].role : "";
                          if(loggedUserRole === 'TenantAdmin') {
                            history.push(`/admin/edit-user/${data.userId}`);
                          } else {
                            history.push(`/admin/edit-user/${data.userId}`);
                          }
                        }}
                        className={dropdownItem}
                      >
                        {rtlActive ? "الملف الشخصي" : "Profile"}
                      </MenuItem>
                      <Divider light />
                      <MenuItem
                        onClick={() => {
                          localStorage.removeItem("user-custom-details");
                          localStorage.removeItem("termAndCondtions");
                          localStorage.removeItem("changePassword");
                          localStorage.removeItem("user-details");
                          localStorage.removeItem("fdaView");
                          clearApiCache();
                          history.push("/auth/login");
                        }}
                        className={dropdownItem}
                      >
                        {rtlActive ? "الخروج" : "Log out"}
                      </MenuItem>
                    </MenuList>
                  </ClickAwayListener>
                </Paper>
              </Grow>
            )}
          </Popper>
        </div>
      </div>
    </Box>
  );
}

HeaderLinks.propTypes = {
  rtlActive: PropTypes.bool,
};
